import { P, Small, Strong } from '@ahmdigital/ui';
import styled from 'styled-components';

export const StyledSmall = styled(Small)`
  vertical-align: top;
`;
export const ambulanceDisclaimerTasQld = (
  <P>^TAS/QLD State schemes cover ambulance services for residents of those States.</P>
);

export const ambulanceIntro = {
  feature: (
    <>
      <Strong>Unlimited Medically Necessary Ambulance</Strong> means that we’ll help with the ambulance fees for
      medically necessary ambulance transport to the nearest hospital^.
    </>
  ),
  featureDisclaimer: (
    <P>
      ^Transport to the nearest hospital provided by an ahm approved road, sea or air Ambulance provider that’s able to
      provide the level of care you medically need. Some ahm products limit the number of Ambulance services we’ll pay
      benefits towards per financial year. Check your Product Guide to see if any limits apply. Your Daily Charge and/or
      Excess doesn’t apply to Ambulance claims.
    </P>
  ),
};

export const dependantsExcess = <Strong>No excess for dependants</Strong>;
